import React from "react";
import getSize from "../../../utils/getSize";
import NHTable from '../../common/NHTable';
import css from './index.css';
import { message, Button, Table, Select, Input } from 'antd';
import { hasAuth, createUuid } from "../../../utils/NHCore";

class LstdblcxIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            frameVisibleMap: {
                tableFlag: true,
            }
        };
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }



handleOtpBtnClick = () => {
    this.refs.nhTable.exportExcel('绿色通道办理信息');
}
    render() {
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '90px',
                searchType:"input"
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType:"input"
            }, {
                title: '姓名',
                dataIndex: 'XM',
                width: '90px',
                searchType:"input"
            }, {
                title: '办理原因',
                width: '200px',
                dataIndex: 'BLYY',
                searchType:"input"
            }, {
                title: '办理金额(元)',
                width: '120px',
                dataIndex: 'BLJE',
                searchType:"input"
            }, {
                title: '申请说明',
                width: '250px',
                dataIndex: 'SQSM',
                searchType:"input"
            }, {
                title: '办理时间',
                width: '150px',
                dataIndex: 'BLSJ',
                commonSearch:false,
                searchType:"date"
            }
        ];
        
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable
                        ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_tjcx_lstd_queryPage"}
                        columns={columns}
                        rangeFilter={true}
                    >
                        {hasAuth("zhxg_yxgl_tjcx_lstdblcx:export") ? <Button type="primary" ghost onClick={this.handleOtpBtnClick} style={{ marginLeft: 10 }}>导出</Button> : undefined}

                    </NHTable>
                </div>
            </div>
        );
    }
}
export default LstdblcxIndex;



// WEBPACK FOOTER //
// ./components/tjcx/lstdblcx/index.js